import { v4 as uuid } from "uuid";

export const categories = [
  {
    _id: uuid(),
    categoryName: "All",
  },
  {
    _id: uuid(),
    categoryName: "Breakfast",
  },
  {
    _id: uuid(),
    categoryName: "Lunch",
  },
  {
    _id: uuid(),
    categoryName: "Dinner",
  },
  {
    _id: uuid(),
    categoryName: "Snacks",
  },
];
